// extracted by mini-css-extract-plugin
export default {"containerWrapper":"C-EGRMfpuIbAZXUAmjPi4"};